import type { IEntityModel } from './base'
import type { IDigestParticipant } from './digest_participant'
import type { IParticipant } from './participant'
import type { IProject } from './project'
import type { ITask } from './task'
import type { IWorkspace } from './workspace'

export enum DigestParticipantItemType {
  Todo = 'todo',
  Timer = 'timer',
  Questionnaire = 'questionnaire',
  GarminDevice = 'garmin_device',
  StopwatchMovesenseStream = 'stopwatch_movesense_stream',
  StopwatchGarminStream = 'stopwatch_garmin_stream',
  GarminConnect = 'garamin_connect',
}

export interface IDigestParticipantItem extends IEntityModel {
  taskId?: string
  projectId: string
  workspaceId: string
  participantId: string
  digestParticipantId: string
  unixTimestampStart?: number | null
  unixTimestampComplete?: number | null
  type: DigestParticipantItemType
  data?: Record<string, boolean | string | number>
  task?: ITask
  project?: IProject
  workspace?: IWorkspace
  participant?: IParticipant
  digestParticipant?: IDigestParticipant
}
